import { FeatureOwners } from '@/scopes/common/infrastructure/feature-flags/constants'
import { flag } from '@/scopes/common/infrastructure/feature-flags/flag'

export const FEATURE_FLAGS = {
  ACTIVATE_DK_SEARCH: flag({ name: 'DK Search', owner: FeatureOwners.BAHAMAS }),
  ACTIVATE_UDS_SEARCH: flag({ name: 'UDS Search', owner: FeatureOwners.MAUI }),
  ACTIVATE_UDS_SEARCH_PRODUCT_CARD: flag({ name: 'UDS Search product card', owner: FeatureOwners.MAUI }),
  ACTIVATE_UDS_SEARCH_QUICKSEARCH: flag({ name: 'UDS Search quick search', owner: FeatureOwners.MAUI }),
  ACTIVATE_FULL_REACT_PDP: flag({ name: 'Full React PDP', owner: FeatureOwners.KYOTO }),
  SHOW_GROUPS_BUS_MORE_THAN_ONE_PICKUP_POINT: flag({
    name: 'Show groups bus more than one pickup point',
    owner: FeatureOwners.KOS,
  }),
  SHOW_GROUPS_BUS_PICKUP_POINT_KNOWN: flag({
    name: 'Show groups bus pick point known',
    owner: FeatureOwners.KOS,
  }),
  SHOW_CAR_RENTAL_FILTERING_SERVICE: flag({
    name: 'Show car rental filtering service',
    owner: FeatureOwners.KOS,
  }),
  ENABLE_NEW_PRICE_TABLE: flag({
    name: '',
    owner: FeatureOwners.BAHAMAS,
  }),
  OPTIMIZE_TRANSLATION_IMPORT: flag({
    name: 'Optimize translation import with dynamic import',
    owner: FeatureOwners.MAUI,
  }),
  ACTIVATE_REACT_CHECKOUT_STEP_2: flag({
    name: 'Activate step 2 checkout',
    owner: FeatureOwners.MALLORCA,
  }),
  ENABLE_AI_FILTER: flag({
    name: '',
    owner: FeatureOwners.BAHAMAS,
  }),
  ENABLE_DEEPLINKING: flag({
    name: '',
    owner: FeatureOwners.BAHAMAS,
  }),
  ENABLE_AB_BYWEEKS: flag({
    name: '',
    owner: FeatureOwners.BAHAMAS,
  }),
  ENABLE_PROFILE_PAGE: flag({
    name: 'Enable Profile Page',
    owner: FeatureOwners.RIO,
  }),
  ENABLE_MARKETING_PREFERENCES_PAGE: flag({
    name: 'Enable Marketing Preferences Page',
    owner: FeatureOwners.RIO,
  }),
} as const

export const ACTIVE_FEATURE_FLAGS: FeatureFlagId[] = []

export type FeatureFlagId = keyof typeof FEATURE_FLAGS
